/**
 * @generated SignedSource<<eeaa3581897228bc226a98abcbd61a8c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTicketLinkInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteTicketLinkMutation$variables = {
  input: DeleteTicketLinkInput;
};
export type deleteTicketLinkMutation$data = {
  readonly deleteTicketLink: {
    readonly clientMutationId: string | null;
    readonly deletedTicketLinkId: string;
  } | null;
};
export type deleteTicketLinkMutation = {
  variables: deleteTicketLinkMutation$variables;
  response: deleteTicketLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTicketLinkPayload",
    "kind": "LinkedField",
    "name": "deleteTicketLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedTicketLinkId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteTicketLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteTicketLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e9ebc2e711344768d6b6078bfd01cdbf",
    "id": null,
    "metadata": {},
    "name": "deleteTicketLinkMutation",
    "operationKind": "mutation",
    "text": "mutation deleteTicketLinkMutation(\n  $input: DeleteTicketLinkInput!\n) {\n  deleteTicketLink(input: $input) {\n    clientMutationId\n    deletedTicketLinkId\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f27044037901c701ea8f1446352f9d8";

export default node;
